import styled from 'styled-components';

export const ContainerQRCode = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
